class ImportProfile {
  constructor(data) {
    data = data || {};

    this.id = data.id || '';
    this.name = data.fullName || '';
    this.email = data.email || '';
    this.phone = data.phoneNumber || '';
    this.customerNumber = data.customerNr || [];

    this.company = data.company || '';
    this.currentLanguage = data.language.toLowerCase() || 'en';
    this.jobTitle = data.jobTitle || '';

    this.manufacturer = '';
    this.dateFormat = data.dateFormat || '';
    this.metricData = data.metricData;

    this.estimatedProduction = data.estimatedProduction || 'KilogramPerHour';
    this.productNews = data.receiveNews;
    this.imageUrl = data.picture;
    this.profilePicture = data.picture;
    this.acceptedToS = data.acceptedToS;
    this.oems = data.oems.map(oem => {
      return oem.id;
    });
  }
}

class EditProfile {
  constructor(data) {
    data = data || {};

    this.name = data.name;
    this.email = data.email;
    this.company = data.company;
    this.jobTitle = data.jobTitle;
    this.phoneNumber = data.phone;
    this.metricData = data.metricData;
    this.userLanguage = data.currentLanguage;
    this.estimatedProduction = data.estimatedProduction;
    this.receiveNews = data.productNews;
    this.dateFormat = data.dateFormat;
    this.profilePicture = data.profilePicture;
    this.region = data.region;
    this.oems = data.oems;
  }
}

class NotificationItemModel {
  constructor(data) {
    data = data || {};

    this.unitName = data.unitName;
    this.urlGuid = data.urlGuid;
    this.notificationsEnabled = data.notificationsEnabled;
    this.emailsEnabled = data.emailsEnabled;

    this.grindingType = isNaN(data.grinding.type) ? null : data.grinding.type;
    this.grindingValue = isNaN(data.grinding.value) ? null : data.grinding.type !== null && data.grinding.type === 0 ? parseInt(data.grinding.value/1000) : data.grinding.value;
    this.replacementType = isNaN(data.replacement.type) ? null : data.replacement.type;
    this.replacementValue = isNaN(data.replacement.value) ? null : data.replacement.type !== null && data.replacement.type === 0 ? parseInt(data.replacement.value/1000) : data.replacement.value;
  }
}

export { ImportProfile, EditProfile, NotificationItemModel };
